import { isDevMode } from '@angular/core';
import { MeshUtils } from '@3d-scene/common/util/mesh-utils';
import { ConfiguratorScene } from '@3d-scene/scene/configurator-scene';
import { CameraHelper } from 'three';

export class DebugDraw {
  // change value of this field manually in code in order to activate debug mode (show axes for articles, log into console etc.)
  private static _enabledManually = false;
  private static _active: boolean = this._enabledManually && isDevMode();

  public static get active(): boolean {
    return this._active;
  }

  public static addDebugElementsToScene(configuratorScene: ConfiguratorScene): void {
    configuratorScene.addObjectToScene(MeshUtils.createAxesWithLabels(500, configuratorScene.defaultFont));
    if (this.active) {
      configuratorScene.scene.add(new CameraHelper(configuratorScene.camera));
    }

    configuratorScene.renderScene();
  }
}
